import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";

const FAQS = [
  {
    q: "Quel est le délai d'intervention pour un débouchage de canalisation dans le 93 ?",
    a: "Notre délai d'intervention moyen est de 30 minutes dans toute la Seine-Saint-Denis. En cas d'urgence, un technicien est dépêché immédiatement, 24h/24 et 7j/7, jours fériés compris.",
  },
  {
    q: "Combien coûte un débouchage de canalisation ?",
    a: "Le tarif dépend du type d'intervention (WC, évier, colonne...) et de la technique nécessaire (furet, hydrocurage, caméra). Nous établissons systématiquement un devis ferme et écrit avant toute intervention, sans frais cachés ni majoration nocturne abusive.",
  },
  {
    q: "Faut-il démonter ma cuvette de WC pour la déboucher ?",
    a: "Dans 95% des cas, non. Nos plombiers utilisent un furet adapté ou une pompe de débouchage spécifique qui permet de retirer le bouchon sans démonter la cuvette ni détériorer votre salle de bain.",
  },
  {
    q: "Mon évacuation se bouche régulièrement, que faire ?",
    a: "Une obstruction récidivante traduit souvent un problème structurel : pente insuffisante, fissure, racines ou dépôts incrustés. Nous passons une caméra endoscopique pour identifier la cause exacte et vous proposons un curage haute pression durable plutôt qu'un simple débouchage temporaire.",
  },
  {
    q: "Intervenez-vous la nuit et le week-end ?",
    a: "Oui. Nous fonctionnons en astreinte 24h/24, 7j/7 et jours fériés inclus, sans majoration abusive sur les interventions urgentes simples. Vous payez le même tarif clair qu'en pleine journée.",
  },
  {
    q: "Êtes-vous assurés et garantissez-vous votre travail ?",
    a: "Tous nos plombiers sont assurés en responsabilité civile professionnelle et couverts par une garantie décennale. Chaque intervention est garantie 3 mois : si le bouchon revient au même endroit, nous repassons gratuitement.",
  },
  {
    q: "Acceptez-vous les paiements par carte bancaire ?",
    a: "Oui, nos techniciens disposent de terminaux mobiles. Vous pouvez régler par carte bancaire, chèque, virement ou espèces. Une facture nominative détaillée vous est remise systématiquement.",
  },
  {
    q: "Travaillez-vous avec les syndics et bailleurs sociaux ?",
    a: "Absolument. Nous sommes partenaires de nombreux syndics de copropriété et bailleurs sociaux du 93 pour des contrats d'entretien préventif et des interventions d'urgence sur leur parc immobilier.",
  },
];

export const Faq = () => (
  <section id="faq" className="py-20 md:py-28 bg-white">
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="text-xs sm:text-sm font-bold uppercase tracking-[0.25em] text-[#FF5A1F] mb-4">
        Questions fréquentes
      </div>
      <h2
        className="text-4xl sm:text-5xl font-extrabold tracking-tight text-[#0F172A] mb-10"
        style={{ fontFamily: "'Cabinet Grotesk','Manrope', sans-serif" }}
      >
        Tout ce que vous devez savoir.
      </h2>

      <Accordion type="single" collapsible className="space-y-3">
        {FAQS.map((f, i) => (
          <AccordionItem
            key={i}
            value={`item-${i}`}
            data-testid={`faq-item-${i}`}
            className="bg-white border border-slate-200 rounded-2xl px-5"
          >
            <AccordionTrigger className="text-left font-bold text-[#0F172A] hover:no-underline py-5">
              {f.q}
            </AccordionTrigger>
            <AccordionContent className="text-slate-600 leading-relaxed pb-5 text-base">
              {f.a}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  </section>
);

export default Faq;
